
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retailerCampaign",
      function () {
        return require("private-next-pages/retailerCampaign.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retailerCampaign"])
      });
    }
  